import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CookieService } from 'src/app/shared/services/cookie.service';

@Injectable()
export class XClientKeyInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // 'skip-client-key' is a signal for this interceptor only - strip it
    // before forwarding so it never reaches the backend as a real header.
    if (request.headers.has('skip-client-key')) {
      return next.handle(
        request.clone({ headers: request.headers.delete('skip-client-key') })
      );
    }
    if (request.url.includes(environment.scsoftUrl.base)) {
      const authRequest = request.clone({
        headers: request.headers
        .append('Access-Control-Allow-Origin', '*')
        .append('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS')
        .append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token'),
      });
      return next.handle(authRequest);
    }
    // All non-SCSoft API calls now authenticate with the token returned by
    // POST auth/get-auth/ (see BreezeService.registerAuthSession), sent as
    // an Authorization: Bearer header, instead of the old static
    // x-client-key. Requests made before login (no token yet) go out
    // without an Authorization header - see project notes on pre-login
    // calls needing a backend-confirmed auth story.
    const reportAuthToken = this.cookieService.get(
      this.cookieService.REPORT_AUTH_TOKEN
    );
    const authRequest = reportAuthToken
      ? request.clone({
          headers: request.headers.set(
            'Authorization',
            `Bearer ${reportAuthToken}`
          ),
        })
      : request;
    return next.handle(authRequest);
  }
}
